import moment from 'moment';

/**
 * 基础时间格式转换函数
 * @param {Date|Number|String} value 时间值
 * @param {String} pattern 格式化字符串
 * @param {Object} options 其他可选项：
 * 1.invalidResult：value为非法时间值时的返回内容，默认为“--”
 * @returns
 */
const baseTimeFormatter = (value, pattern, options = {}) => {
  const { invalidResult = '--' } = options;

  const obj = moment(value);
  return obj._isValid ? obj.format(pattern) : invalidResult;
};

/**
 * 年月日格式转换函数
 * @param {Date|Number|String} value 时间值
 * @param {String} pattern 格式化字符串，默认为'YYYY-MM-DD'
 * @param {Object} options 其他可选项：
 * 1.invalidResult：value为非法时间值时的返回内容，默认为“--”
 * @returns
 */
export const dateFormatter = (value, pattern = 'YYYY-MM-DD', options) => {
  return baseTimeFormatter(value, pattern, options);
};

/**
 * 月日格式转换函数
 * @param {Date|Number|String} value 时间值
 * @param {String} pattern 格式化字符串，默认为'MM-DD'
 * @param {Object} options 其他可选项：
 * 1.invalidResult：value为非法时间值时的返回内容，默认为“--”
 * @returns
 */
export const simpleDateFormatter = (value, pattern = 'MM-DD', options) => {
  return baseTimeFormatter(value, pattern, options);
};

/**
 * 年月日时分秒格式转换函数
 * @param {Date|Number|String} value 时间值
 * @param {String} pattern 格式化字符串，默认为'YYYY-MM-DD HH:mm:ss'
 * @param {Object} options 其他可选项：
 * 1.invalidResult：value为非法时间值时的返回内容，默认为“--”
 * @returns
 */
export const datetimeFormatter = (value, pattern = 'YYYY-MM-DD HH:mm:ss', options) => {
  return baseTimeFormatter(value, pattern, options);
};

/**
 * 月日时分格式转换函数
 * @param {Date|Number|String} value 时间值
 * @param {String} pattern 格式化字符串，默认为'MM-DD HH:mm'
 * @param {Object} options 其他可选项：
 * 1.invalidResult：value为非法时间值时的返回内容，默认为“--”
 * @returns
 */
export const simpleDatetimeFormatter = (value, pattern = 'MM-DD HH:mm', options) => {
  return baseTimeFormatter(value, pattern, options);
};

/**
 * 数值添加千位分隔符
 * @param {Number} value 待转换数值
 * @param {Object} options 其他可选项：
 * 1.splitter：千位分隔符，默认为“,”
 * @returns
 */
export const thousandFormatter = (value, options = {}) => {
  const { splitter = ',' } = options;

  return value.toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + splitter;
    });
  });
};

/**
 * 金额格式转换
 * @param {Number} value 金额数值
 * @param {String} prefix 币种符号，默认为“￥”
 * @param {Object} options 其他可选项：
 * 1.splitter：千位分隔符，默认为“,”
 * @returns
 */
export const moneyFormatter = (value, prefix = '￥', options) => {
  return `${prefix}${thousandFormatter(value, options)}`;
};

/**
 * 计量单位转换
 * @param {Number} value 待转换数值
 * @param {Number} base 转换基数，默认为1000
 * @param {Object} options 其他可选项：
 * 1.suffixes：转换后缀数组，默认为 ['', 'K', 'M', 'T', 'P']
 * 2.precision：转换后的小数点精度，默认为 2
 * @returns
 */
export const unitFormatter = (value, base = 1000, options = {}) => {
  const { suffixes = ['', 'K', 'M', 'T', 'P'], precision = 2 } = options;

  if (value === 0) {
    return `0${suffixes[0]}`;
  }

  const i = Math.floor(Math.log(value) / Math.log(base));

  return suffixes[i] !== undefined ? +(value / Math.pow(base, i)).toFixed(precision) + suffixes[i] : value;
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/xpc/formatter.js